import React from 'react';

const DanceInDarkPage = () => {
    return (
      <div class="background" style={{ backgroundImage: `url("https://cdn.pixabay.com/photo/2017/12/12/12/44/bitcoin-3014614_960_720.jpg")`}}>
            <div class="title">
                <h3 style={{paddingTop: 3}}>DANCE IN THE DARK WEB</h3>
            </div>
            <div>
            <h4 style={{color: 'Beige'}}>Haxx0r ipsum rsa protocol packet baz crack rm -rf mega root script kiddies kilo I'm sorry Dave, I'm afraid I can't do that I'm compiling var. Ifdef todo foad void dereference bubble sort vi double fopen. Pwned mailbomb packet sniffer int Dennis Ritchie thread spoof epoch pragma January 1, 1970 pwned wannabee nak piggyback eaten by a grue wabbit.</h4>
            </div>
              <div
                  className="video dark"
                  style={{
                  position: "relative",
                  left: 510,
                  paddingTop: 50,
                  paddingBottom: 20
                }}
                >
                  <iframe width="832" height="469" src="https://www.youtube.com/embed/wmin5WkOuPw?autoplay=1" frameborder="0" allow="accelerometer; allow=autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;" allowfullscreen></iframe>
              </div>  
            
            <div>
              <img class='icon' src="https://freepngimg.com/download/onion/75701-web-onion-icons-tor-computer-routing-.onion.png"/>
                {/* <img class='icon' src="https://cdn0.iconfinder.com/data/icons/flat-round-system/512/tor-512.png"/> */}
                {/* <img class='icon' src="https://png2.cleanpng.com/sh/c02147a86008291db00391b38d209959/L0KzQYm3VcEyN5l9iZH0aYP2gLBuTgRwel50htt4bj36dbO0gwJwf6Rqip94bnnyfn75jCV1cZ9sRdV4bYD4hLb5Tflkd58yTdNvNXPkQIa7WfM4PWkzSqkEOUS3Q4i4VcI3OGY8TKkCM0C1QnB3jvc=/kisspng-tor-onion-web-browser-onion-routing-computer-icon-5af5ca0549c758.2799443715260574773022.png"/> */}
            </div>
      </div>
    );                                                                                                                                                                                                                                                                                                                                                                                                            
}
 
export default DanceInDarkPage;



